import Api from './Api'
import { store } from '../store/index'

function getOrgId() {
  return store.getters['user/getOrgContext'] || store.getters['user/getOrgId']
}

export default class DocumentService {
  constructor() { }


  static async updateTableRow(id, updatedData) {
    let url = `/adr/api/v1/last-documents/${id}`;
    // console.log(id, updatedData);
    try {
      // 'true' means we omit the userId query param
      let response = await new Api(true).patch(url, updatedData);
      return response;
    } catch (err) {
      return err.response;
    }
  }

  static async resetMetadata(docId) {
    let url = `/adr/api/v1/last-documents/${docId}/metadata`;
    try {
      // 'true' means we omit the userId query param
      let response = await new Api(true).delete(url);
      return response;
    } catch (err) {
      return err.response;
    }
  }
}
